var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.isLocalLink ? 'nuxt-link' : 'a',{tag:"component",staticClass:"one-cms-grid-link",attrs:{"href":_vm.link,"to":_vm.link,"target":_vm.target}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }